"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.access.denied.title': 'Acceso Denegado',
    'reports.access.denied.enterprise': 'Los usuarios empresariales no tienen acceso a los informes de costos.',
    'reports.access.denied.general': 'Solo los usuarios principales y los súper administradores pueden acceder a los informes de costos.',
};
